module.exports = __webpack_public_path__ + "static/media/KABA.b32c3558.png";